module.exports = __webpack_public_path__ + "img/ileti_app.99da3426.png";